import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import "../styles/clients.css";
import ClientPopUp from "./client_popup.js";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const ClientsSearch = (props) => {
  const [clientsReportValue, setClientsReportValue] = useState([]);
  const [showClientReport, setShowClientReport] = useState(false);
  const [showAddClient, setShowAddClient] = useState(false);
  const [showStatistics, setShowStatistics] = useState(false);
  const [nameSearch, setNameSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState("");
  const [clients, setClients] = useState([]);
  const [clientsContacts, setClientsContacts] = useState([]);
  const [clientsClear, setClientsClear] = useState([]);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);
  const [timer, setTimer] = useState(null);
  const [search, setSearch] = useState(false);

  const fetchClients = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClients", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClients(getAllowedClients(data));
        setClientsClear(getAllowedClients(data));
        handleFilterChangeRefresh("", "", getAllowedClients(data));
        handleSortChangeRefresh();
        fetchClientsContacts();
      })
      .catch((error) => {});
  };

  const fetchClientsContacts = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsContacts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsContacts(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchClientsAll = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClients(getAllowedClients(data));
        setClientsClear(getAllowedClients(data));
        handleFilterChangeRefresh("", "", getAllowedClients(data));
        handleSortChangeRefresh();
        fetchClientsContacts();
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const getData = () => {
    setLoading(true);
    if (props.team === 0) {
      fetchClientsAll();
    } else {
      fetchClients();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setClientsReportValue(value);
    handleShowClientReport();
  };

  const handleShowClientReport = () => {
    setShowClientReport(true);
  };

  const closeClientReport = () => {
    setShowClientReport(false);
    getData();
  };

  const scrollTop = (e) => {
    const divToScrollTo = document.getElementById("testScroll");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const clientsData = (
    <>
      {search ? (
        <>
          <p style={{ fontSize: ".8vw", textAlign: "right" }}>
            Liczba spraw: {clients.length}
          </p>
          <table className="clients_table">
            <tr key={0}>
              <th>Lp.</th>
              <th>Powód</th>
              <th>Prawnik</th>
              <th>Status sprawy</th>
              <th>Aktualna sygnatura sprawy</th>
              <th>Sąd</th>
              <th>Bank</th>
              <th>WPS</th>
              <th>Rodzaj sprawy</th>
            </tr>
            {clients.map((el) => (
              <>
                <tr
                  style={el.arch === "1" ? { backgroundColor: "yellow" } : {}}
                  id={""}
                  key={el.id}
                >
                  <td value={el.id} onClick={handleRowClick}>
                    {el.id_old}
                  </td>
                  <td
                    style={{
                      textAlign: "left",
                      paddingLeft: "5px",
                      fontWeight: "600",
                      maxWidth: "15%",
                      wordBreak: "break-word",
                    }}
                    value={el.id}
                    onClick={handleRowClick}
                  >
                    {el.petitioner}{" "}
                    {props.team === 0 ? (
                      <>
                        <span style={{ color: "green" }}>
                          - zespół {el.team}
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.client_owner}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.status}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.aSygn}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.aCourt}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.bank}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.wps === "" || el.wps === undefined
                      ? "brak danych"
                      : numberWithCommas(el.wps) + " PLN"}
                  </td>
                  <td
                    style={{
                      wordBreak: "break-word",
                      width: "15%",
                      padding: "10px",
                    }}
                    value={el.id}
                    onClick={handleRowClick}
                  >
                    {el.type}
                  </td>
                </tr>
              </>
            ))}
          </table>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              width: "100%",
              alignItems: "flex-end",
              marginTop: "5vh",
            }}
            className="searchBoxP"
          >
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={scrollTop}
            >
              Przejdź na górę listy
            </button>
          </div>
        </>
      ) : (
        "brak wyników"
      )}
    </>
  );

  const clientsDataMobile = (
    <>
      {search ? (
        <>
          <p style={{ fontSize: "2vw", textAlign: "right" }}>
            Liczba spraw: {clients.length}
          </p>
          <table className="clients_table">
            <tr key={0}>
              <th style={{ fontSize: "2vw" }}>Lp.</th>
              <th style={{ fontSize: "2vw" }}>Powód</th>
              <th style={{ fontSize: "2vw" }}>Prawnik</th>
              <th style={{ fontSize: "2vw" }}>Status sprawy</th>
            </tr>
            {clients.map((el) => (
              <>
                <tr
                  style={el.arch === "1" ? { backgroundColor: "yellow" } : {}}
                  id={""}
                  key={el.id}
                >
                  <td value={el.id} onClick={handleRowClick}>
                    {el.id_old}
                  </td>
                  <td
                    style={{
                      textAlign: "left",
                      paddingLeft: "5px",
                      fontWeight: "600",
                      maxWidth: "15%",
                      wordBreak: "break-word",
                    }}
                    value={el.id}
                    onClick={handleRowClick}
                  >
                    {el.petitioner}{" "}
                    {props.team === 0 ? (
                      <>
                        <span style={{ color: "green" }}>
                          - zespół {el.team}
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.client_owner}
                  </td>
                  <td value={el.id} onClick={handleRowClick}>
                    {el.status}
                  </td>
                </tr>
              </>
            ))}
          </table>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              width: "100%",
              alignItems: "flex-end",
              marginTop: "5vh",
            }}
            className="searchBoxP"
          >
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={scrollTop}
            >
              Przejdź na górę listy
            </button>
          </div>
        </>
      ) : (
        "brak wyników"
      )}
    </>
  );

  const checkContacts = (id, value) => {
    var cc = clientsContacts.filter((el) => +el.clientId === +id);

    var bool = false;
    cc.map((e) => {
      if (
        e.content
          .toString()
          .toLowerCase()
          .includes(value.toString().toLowerCase())
      ) {
        bool = true;
      }
    });

    return bool;
  };

  const handleFilterChange = (type, value) => {
    setSearch(true);
    var arr = clientsClear;

    if ((type === "name" ? value : nameSearch).length > 0) {
      arr = arr.filter((el) =>
        el.note
          ? el.note
              .toString()
              .toLowerCase()
              .includes(
                (type === "name" ? value : nameSearch).toString().toLowerCase()
              )
          : false || checkContacts(el.id, type === "name" ? value : nameSearch)
      );
    }

    setClients(arr);
  };

  const handleFilterChangeRefresh = (type, value, data) => {
    var arr = data;

    if ((type === "name" ? value : nameSearch).length > 0) {
      arr = arr.filter((el) =>
        el.note
          ? el.note
              .toString()
              .toLowerCase()
              .includes(
                (type === "name" ? value : nameSearch).toString().toLowerCase()
              )
          : false || checkContacts(el.id, type === "name" ? value : nameSearch)
      );
    }

    setClients(arr);
  };

  const handleNameSearchChange = (e) => {
    setNameSearch(e.target.value);
    if (e.target.value === "") {
      setSearch(false);
    }

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      handleFilterChange("name", e.target.value);
    }, 500);

    setTimer(newTimer);
  };

  const handleFilterClear = () => {
    setSearch(false);
    setNameSearch("");
    setClients(clientsClear.filter((el) => el.arch === "0"));
    setSort("");
  };

  const handleSortChange = (e) => {
    setLoading(true);
    if (e.target.value === "sort1") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw) -
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw)
        )
      );
    } else if (e.target.value === "sort2") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw) -
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw)
        )
      );
    } else if (e.target.value === "sort3") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            ) -
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            )
        )
      );
    } else if (e.target.value === "sort4") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            ) -
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            )
        )
      );
    } else if (e.target.value === "sort5") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw) -
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw)
        )
      );
    } else if (e.target.value === "sort6") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw) -
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw)
        )
      );
    } else if (e.target.value === "sort7") {
      setClients(clients.sort((a, b) => +a.id - +b.id));
    } else if (e.target.value === "sort8") {
      setClients(clients.sort((a, b) => +b.id - +a.id));
    }

    setSort(e.target.value);
    setLoading(false);
  };

  const handleSortChangeRefresh = (e) => {
    if (sort === "sort1") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw) -
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw)
        )
      );
    } else if (sort === "sort2") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw) -
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw)
        )
      );
    } else if (sort === "sort3") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            ) -
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            )
        )
      );
    } else if (sort === "sort4") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            ) -
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            )
        )
      );
    } else if (sort === "sort5") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw) -
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw)
        )
      );
    } else if (sort === "sort6") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw) -
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw)
        )
      );
    } else if (sort === "sort7") {
      setClients(clients.sort((a, b) => +a.id - +b.id));
    } else if (sort === "sort8") {
      setClients(clients.sort((a, b) => +b.id - +a.id));
    }
  };

  const scrollBottom = (e) => {
    const divToScrollTo = document.getElementById("testScroll");
    window.scrollTo({
      top: divToScrollTo.clientHeight,
      behavior: "smooth",
    });
  };

  const createExcelDS = () => {
    var tab = [];
    tab.push([
      "ID",
      "Powód",
      "Prawnik",
      "Status sprawy",
      "Aktualna sygnatura",
      "Aktualny sąd",
      "Bank",
      "Notatka do sprawy",
      "Wniosek o zabezpieczenie",
      "Data otrzymania zaświadczenia od klienta",
      "Sporządzający wezwanie do zapłaty",
      "Data wezwania do zapłaty",
      "Osoba odpowiedzialna za pozew",
      "Osoba sprawdzająca pozew",
    ]);
    clients.map((el) => {
      tab.push([
        el.id_old,
        el.petitioner,
        el.client_owner,
        el.status,
        el.aSygn,
        el.aCourt,
        el.bank,
        el.note,
        el.application_for_protection,
        el.data_zasw,
        el.praw_wezw,
        el.data_wezw,
        el.praw_pozew,
        el.praw_spr_pozew,
      ]);
    });
    return tab;
  };

  const getSum = () => {
    var sum = 0;
    var quant = clients.filter(
      (x) => x.status === "zakończona - rozliczona"
    ).length;
    clients
      .filter((x) => x.status === "zakończona - rozliczona")
      .map((el) => {
        sum = sum + el.paymentsToSettValue;
      });

    return sum / quant;
  };

  const getSum2 = () => {
    var sum = 0;
    var quant = clients.filter(
      (x) => x.status === "zakończona - rozliczona"
    ).length;
    clients
      .filter((x) => x.status === "zakończona - rozliczona")
      .map((el) => {
        sum = sum + el.paymentsPayValue;
      });

    return sum / quant;
  };

  const createExcelIN = () => {
    var tab = [];
    tab.push([
      "ID",
      "Powód",
      "Prawnik",
      "Status sprawy",
      "Aktualna sygnatura",
      "Aktualny sąd",
      "Bank",
      "Notatka do sprawy",
      "Wniosek o zabezpieczenie",
      "Data otrzymania zaświadczenia od klienta",
      "Sporządzający wezwanie do zapłaty",
      "Data wezwania do zapłaty",
      "Osoba odpowiedzialna za pozew",
      "Osoba sprawdzająca pozew",
    ]);
    clients
      .filter((x) => x.status === "zakończona - rozliczona")
      .map((el) => {
        tab.push([
          el.id_old,
          el.petitioner,
          el.client_owner,
          el.status,
          el.closeDate !== null && el.closeDate !== "" > 0
            ? el.closeDate
            : "nie uzupełniono",
          el.paymentsToSettValue.toFixed(2).toString().replaceAll(".", ","),
          el.paymentsPayValue.toFixed(2).toString().replaceAll(".", ","),
        ]);
      });
    tab.push(["", "", "", "", "", "", ""]);

    tab.push([
      "Średnia",
      "",
      "",
      "",
      "",
      getSum().toFixed(2).toString().replaceAll(".", ","),
      getSum2().toFixed(2).toString().replaceAll(".", ","),
    ]);
    return tab;
  };

  const exportToExcel = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const exportToExcelIN = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelIN());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const subMonthsFour = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + 1 - 4));
    return (
      retDate.getFullYear() +
      "-" +
      (retDate.getMonth() < 10
        ? "0" + retDate.getMonth()
        : retDate.getMonth()) +
      "-" +
      (retDate.getDate() < 10 ? "0" + retDate.getDate() : retDate.getDate())
    );
  };

  const desktopFilters = (
    <>
      <div style={{ marginBottom: "0vh" }} className="filtersClients">
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Słowa w notatkach, kontaktach</label>
          <input
            type="text"
            id="clientsFilterInput"
            name="name"
            value={nameSearch}
            onChange={handleNameSearchChange}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            marginBottom: "0vh",
            width: "23.4%",
            gap: "20px",
          }}
          className="searchBoxP"
        >
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={handleFilterClear}
          >
            Wyczyść filtr
          </button>
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={scrollBottom}
          >
            Przejdź na dół listy
          </button>
        </div>
      </div>
      <div
        style={{
          justifyContent: "right",
          marginBottom: "2vh",
          marginTop: "3vh",
        }}
        className="filtersClients"
      >
        {search ? (
          <>
            <div
              style={{ marginBottom: "0vh", width: "23.4%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Sortuj według</label>
              <select
                type="text"
                id="clientsFilterInput"
                name="name"
                value={sort}
                onChange={handleSortChange}
              >
                {sort === "" ? (
                  <option key={10} value="sortX">
                    Wybierz...
                  </option>
                ) : (
                  ""
                )}
                <option key={0} value="sort1">
                  Data otrzymania zaświadczenia - od najstarszej
                </option>
                <option key={1} value="sort2">
                  Data otrzymania zaświadczenia - od najmłodszej
                </option>
                <option key={2} value="sort3">
                  Data nadania pozwu - od najstarszej
                </option>
                <option key={3} value="sort4">
                  Data nadania pozwu - od najmłodszej
                </option>
                <option key={4} value="sort5">
                  Data wezwania do zapłaty - od najstarszej
                </option>
                <option key={5} value="sort6">
                  Data wezwania do zapłaty - od najmłodszej
                </option>
                <option key={6} value="sort7">
                  Według identyfikatora - rosnąco
                </option>
                <option key={7} value="sort8">
                  Według identyfikatora - malejąco
                </option>
              </select>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "3vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            value={props.user.name}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          <div
            style={{ marginTop: "0vh", marginBottom: "0vh" }}
            className="filtersClients"
          >
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">
                Słowa w notatkach, kontaktach
              </label>
              <input
                type="text"
                id="clientsFilterInput"
                name="name"
                value={nameSearch}
                onChange={handleNameSearchChange}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                marginBottom: "0vh",
                width: "100%",
                gap: "20px",
                flexWrap: "wrap",
              }}
              className="searchBoxP"
            >
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  width: "100%",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={handleFilterClear}
              >
                Wyczyść filtr
              </button>
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  width: "100%",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={scrollBottom}
              >
                Przejdź na dół listy
              </button>
            </div>
          </div>

          {search ? (
            <>
              <div
                style={{
                  justifyContent: "right",
                  marginBottom: "2vh",
                  marginTop: "3vh",
                }}
                className="filtersClients"
              >
                <div
                  style={{ marginBottom: "0vh", width: "100%" }}
                  className="searchBoxP"
                >
                  <label id="clientsFilterLabel">Sortuj według</label>
                  <select
                    type="text"
                    id="clientsFilterInput"
                    name="name"
                    value={sort}
                    onChange={handleSortChange}
                  >
                    {sort === "" ? (
                      <option key={10} value="sortX">
                        Wybierz...
                      </option>
                    ) : (
                      ""
                    )}
                    <option key={0} value="sort1">
                      Data otrzymania zaświadczenia - od najstarszej
                    </option>
                    <option key={1} value="sort2">
                      Data otrzymania zaświadczenia - od najmłodszej
                    </option>
                    <option key={2} value="sort3">
                      Data nadania pozwu - od najstarszej
                    </option>
                    <option key={3} value="sort4">
                      Data nadania pozwu - od najmłodszej
                    </option>
                    <option key={4} value="sort5">
                      Data wezwania do zapłaty - od najstarszej
                    </option>
                    <option key={5} value="sort6">
                      Data wezwania do zapłaty - od najmłodszej
                    </option>
                    <option key={6} value="sort7">
                      Według identyfikatora - rosnąco
                    </option>
                    <option key={7} value="sort8">
                      Według identyfikatora - malejąco
                    </option>
                  </select>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      {loading ? (
        <LoadingPopup />
      ) : (
        <div id="reportC" className="mainContainerClients">
          {showClientReport ? (
            <ClientPopUp
              logLeadAction={props.logLeadAction}
              generateAnalysis={props.generateAnalysis}
              close={closeClientReport}
              paymentsData={props.paymentsData}
              paymentsSheetData={props.paymentsSheetData}
              transactionsSheetData={props.transactionsSheetData}
              transactionsASheetData={props.transactionsNaSheetData}
              transactionsData={props.transactionsData}
              paymentsArchiveSheetData={props.paymentsArchiveSheetData}
              id={clientsReportValue}
              team={props.team}
              refreshData={props.refreshData}
              user={props.user.name}
              clientsData={
                clients.filter((el) => +el.id === +clientsReportValue)[0]
              }
              clientsSheetData={props.clientsSheetData}
              userRole={props.user.role}
              userMail={props.user.mail}
              userPhone={props.user.phone}
              substitutesData={props.substitutesData}
              tasksData={props.tasksData}
              hearingsData={props.hearingsData}
              hearingsSheetData={props.hearingsSheetData}
              tasksSheetData={props.tasksSheetData}
              lawyersData={props.lawyersData}
              courtsData={props.courtsData}
              banksData={props.banksData}
              users={props.usersData}
              resultsData={props.resultsData}
              tasksTypesData={props.tasksTypesData}
              checkPermissions={props.checkPermissions}
              hearingsTeam2Data={props.hearingsTeam2Data}
              hearingsTeam2SheetData={props.hearingsTeam2SheetData}
              tasksTeam2Data={props.tasksTeam2Data}
              tasksTeam2SheetData={props.tasksTeam2SheetData}
              archTasksTeam2={props.archTasksTeam2}
              archDateTeam2={props.archDateTeam2}
              archDate={props.archDate}
              clientsSygnData={props.clientsSygnData}
              clientsSygnSheetData={props.clientsSygnSheetData}
              actualSygn={
                clientsClear.filter((el) => +el.id === +clientsReportValue)[0]
                  .aSygn
              }
              clientsContactData={props.clientsContactData}
              clientsContactSheetData={props.clientsContactSheetData}
              logClientAction={props.logClientAction}
              clientsLogsData={props.clientsLogsData}
              clientsQuestData={props.clientsQuestData}
              clientsQuestSheetData={props.clientsQuestSheetData}
              tabIndex={props.tabIndex}
              uData={props.user}
              clientsFullData={clients}
              filesData={props.filesData}
            />
          ) : !showAddClient && !showClientReport && !showStatistics ? (
            <>
              <div style={{ width: "100%" }} className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>

              <div className="desktopFilters">{desktopFilters}</div>
              <div className="mobileFilters">{mobileFilters}</div>
              <div id="testScroll" className="contentBoxPayments">
                <div className="desktopFilters">{clientsData}</div>
                <div className="mobileFilters">{clientsDataMobile}</div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default ClientsSearch;
